import { useEffect, useMemo, useState } from 'react';
import { FeedbacksAPI } from '@/api';
import { IManager } from '@/models/admins.model';

export const useManagersOptions = () => {
  const [managers, setManagers] = useState<IManager[]>([]);

  useEffect(() => {
    let cancelled = false;

    FeedbacksAPI.getManagersList()
      .then((response) => {
        if (!cancelled) {
          setManagers(response.data.data ?? []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setManagers([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(() => managers.map((manager) => ({ label: manager.full_name, value: manager.id })), [managers]);
};
